import styled from '@emotion/styled';
import { Grid } from '@kc-console/common-ui';

import GnbGuideLink from './GnbGuideLink';
import GnbHelpdeskLink from './GnbHelpdeskLink';
import GnbItemDivider from './GnbItemDivider';
import GnbLogoLink from './GnbLogoLink';
import GnbRegionSelect from './GnbRegionSelect';

export default function Gnb() {
  return (
    <GnbContainer component={'header'} container justifyContent={'space-between'}>
      <GnbMenuList component={'ul'} container>
        <GnbMenuItem component={'li'} container>
          <GnbLogoLink />
        </GnbMenuItem>
      </GnbMenuList>
      <GnbMenuList component={'ul'} container>
        <GnbMenuItem component={'li'} container>
          <GnbRegionSelect />
          <GnbItemDivider />
          <GnbGuideLink />
          <GnbHelpdeskLink />
        </GnbMenuItem>
      </GnbMenuList>
    </GnbContainer>
  );
}

const GnbContainer = styled(Grid)`
  position: relative;
  max-width: 100vw;
  height: 48px;
  min-width: 800px;
  z-index: ${({ theme }) => theme.zIndex.navigationOverlay};
  background-color: ${({ theme }) => theme.color['surface/global/default']};
`;

const GnbMenuList = styled(Grid)``;

const GnbMenuItem = styled(Grid)`
  align-items: center;
`;
